import React from "react"
import { Tooltip } from "react-bootstrap"

const dynamicFormTootip = (text: string) => (
    <Tooltip id="dynamic-form-tool-tip">
        {text}
    </Tooltip>
)

export default dynamicFormTootip